import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Trash2 } from "react-feather";
import { useFuncionarioPrefeitura } from "../../../Hooks/funcionarioPrefeitura";
import { IPrefeitura, usePrefeitura } from "../../../Hooks/usePrefeitura";
import { IImovelFocus } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import theme from "../../../Styles/theme";
import { logos } from "../../../Utils/baseUrlLogos";
import { ExcluirImovelModal } from "../ExcluirImovelModal";
import { ModalGuia } from "./ModalGuia";
import { ModalMunicipio } from "./ModalMunicipio";
import { Edit as EditIcon } from "@mui/icons-material";

import {
  Container,
  GuiaContainer,
  GuiaInput,
  GuiaTitle,
  MunicipioContainer,
  MunicipioLogo,
  Title,
} from "./styles";

interface Props {
  imovel: IImovelFocus;
  handleSetImovel(im: IImovelFocus): void;
  editavel: boolean;
}
export function Header({ imovel, handleSetImovel, editavel }: Props) {
  const [openModalGuia, setOpenModalGuia] = useState(false);
  const [openModalMunicipio, setOpenModalMunicipio] = useState(false);
  const [openExcluirImovelModal, setExcluirImovelModal] = useState(false);

  const {
    prefeitura,
    prefeituraIsLogged,
    logoPrefeitura,
    bancoPrefeitura,
  } = usePrefeitura();
  const { assets, getPrefeituras, prefeituras } = usePrefeitura();
  const [logo, setLogo] = useState("");
  const {
    funcionarioPrefeituraIsLogged,
    FuncionarioPrefeitura,
  } = useFuncionarioPrefeitura();
  const [numero_guia_intective, setnumero_guia_intective] = useState(false);
  const [GUIA, setGuia] = useState(0);
  function handleSetGuia(n: number) {
    setGuia(n);
    imovel.NUMERO = n;
    handleSetImovel(imovel);
  }

  useEffect(() => {
    if (imovel.NUMERO) setGuia(imovel.NUMERO);
  }, [imovel]);
  useEffect(() => {
    setnumero_guia_intective(
      !!imovel.ENVIADO &&
        !imovel.AVALIADO &&
        (funcionarioPrefeituraIsLogged || prefeituraIsLogged)
    );
  }, [imovel]);

  async function getAssets() {
    try {
      await getPrefeituras(imovel.ID);
    } catch (error) {
      //window.alert("deu erro")
    }
  }
  useEffect(() => {
    if (!prefeituraIsLogged && !funcionarioPrefeituraIsLogged) {
      if (imovel.ID && !prefeituras.length && !assets.length) getAssets();
    } else {
      setLogo(`${logos}/uploads/${logoPrefeitura}`);
    }
  }, [imovel, logoPrefeitura]);
  useEffect(() => {
    if (!prefeituraIsLogged && !funcionarioPrefeituraIsLogged) {
      if (assets && prefeituras && imovel.ID) {
        if (assets.length > 0 && prefeituras.length > 0) {
          setLogo(
            `${logos}/uploads/${assets[defineLogo(imovel.PREFEITURA_ID)].logo}`
          );
          //window.alert(`${logos}/uploads/${assets[defineLogo(imovel.PREFEITURA_ID)].logo}`)
        }
      }
    }
  }, [assets, prefeituras, imovel.PREFEITURA_ID]);

  function defineLogo(id: number): number {
    let index = 0;
    if (assets) {
      if (assets.length > 0) {
        index = assets.findIndex((item) => item.id == id);
      }
    }
    return index;
  }

  useEffect(() => {}, [logo]);

  return (
    <>
      <Container>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: theme.colors.light,
            borderRadius: "0.5rem",
          }}
        >
          <MunicipioContainer
            onClick={() => setOpenModalMunicipio(true)}
            interactive={editavel}
            style={{
              background: theme.colors.light,
              padding: "20px",
              borderRadius: "0.5rem",
              paddingTop: 0,
              paddingBottom: 0,
            }}
          >
            <MunicipioLogo src={logo} />
            <Title>
              ESTADO DO RIO GRANDE DO SUL <br />
              PREFEITURA MUNICIPAL DE {imovel.MUNICIPIO}
              <br />
              SECRETARIA MUNICIPAL DA FAZENDA
              <br />
              GUIA DE ARRECADAÇÃO - ITBI
              <br />
            </Title>
          </MunicipioContainer>
          {editavel && (
            <Button
              variant="text"
              // style={{ fontSize: 10 }}
              startIcon={<EditIcon />}
              onClick={() => {
                // setTransmitenteFocus(transmitente);
                 setOpenModalMunicipio(true);
              }}
            >
              {/* Editar */}
            </Button>
          )}
        </div>

        {/* se ainda nao foi enviado posso excluir! */}
        {
          <GuiaContainer
            onClick={() => setOpenModalGuia(true)}
            interactive={numero_guia_intective}
            style={{ background: theme.colors.light, borderRadius: "0.5rem" }}
          >
            <GuiaTitle>GUIA</GuiaTitle>
            <GuiaInput>
              {GUIA > 0 ? GUIA : "?"}/
              {new Date(imovel.DATA_CRIACAO).getFullYear()}
            </GuiaInput>
          </GuiaContainer>
        }
      </Container>

      {numero_guia_intective ? (
        <ModalGuia
          numeroGuia={GUIA ? GUIA : 0}
          prefeitura_id={imovel.PREFEITURA_ID}
          handleSetGuia={handleSetGuia}
          open={openModalGuia}
          onClose={() => setOpenModalGuia(false)}
        />
      ) : (
        ""
      )}
      {editavel ? (
        <>
          {" "}
          <ModalMunicipio
            open={openModalMunicipio}
            onClose={() => {
              setOpenModalMunicipio(false);
            }}
            imovel={imovel}
            handleSetImovel={handleSetImovel}
          />
        </>
      ) : (
        ""
      )}
    </>
  );
}
